import { writable } from 'svelte/store';
let state = {
    isLoggedIn: false,
    accessToken: '',
    user: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        id: ''
    },
    avatar: "",
};
let auth = () => {
    const { subscribe, set, update } = writable(JSON.parse(localStorage.getItem('auth')) || state);
    subscribe((value) => {
        localStorage.setItem('auth', JSON.stringify(value));
    });
    return {
        subscribe,
        login: (token) => {
            return update((store) => (Object.assign(Object.assign({}, store), { isLoggedIn: true, accessToken: '' })));
        },
        logout: () => {
            return set(state);
        },
        refresh: (token) => update((store) => (Object.assign(Object.assign({}, store), { accessToken: token }))),
        setUser: (user) => {
            return update((store) => (Object.assign(Object.assign({}, store), { user: Object.assign(Object.assign({}, store.user), user) })));
        },
        setMobile: (mobile) => {
            return update((store) => (Object.assign(Object.assign({}, store), { user: Object.assign(Object.assign({}, store.user), { mobile: mobile }) })));
        },
        setEmail: (email) => {
            return update((store) => (Object.assign(Object.assign({}, store), { user: Object.assign(Object.assign({}, store.user), { email: email }) })));
        },
        setAvatar: avatar => update(s => (Object.assign(Object.assign({}, s), { avatar })))
    };
};
export default auth();
